(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["garantia-formulario"] && !Shopify.designMode) return;
  try {
    
  // Mostrar nome do arquivo selecionado
  document.getElementById('nota_fiscal').addEventListener('change', function(e) {
    const fileName = e.target.files[0]?.name || '';
    document.getElementById('file-name').textContent = fileName ? `Arquivo: ${fileName}` : '';
  });

  // Máscara de CPF
  document.getElementById('cpf').addEventListener('input', function(e) {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length <= 11) {
      value = value.replace(/(\d{3})(\d)/, '$1.$2');
      value = value.replace(/(\d{3})(\d)/, '$1.$2');
      value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    }
    e.target.value = value;
  });

  // Envio do formulário
  document.getElementById('garantia-form').addEventListener('submit', async function(e) {
    e.preventDefault();

    const formData = new FormData(this);
    const messageDiv = document.getElementById('form-message');

    try {
      // Aqui você pode integrar com um serviço de envio de formulários
      // Por exemplo: Formspree, Zapier, ou um endpoint customizado

      const response = await fetch('SEU_ENDPOINT_AQUI', {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        messageDiv.textContent = 'Formulário enviado com sucesso! Entraremos em contato em breve.';
        messageDiv.className = 'form-message success';
        this.reset();
        document.getElementById('file-name').textContent = '';
      } else {
        throw new Error('Erro no envio');
      }
    } catch (error) {
      messageDiv.textContent = 'Erro ao enviar formulário. Tente novamente.';
      messageDiv.className = 'form-message error';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
